import React, { useEffect, useRef, useState } from 'react';
import { config } from 'utils/config';
import { i18n } from 'utils/i18n';
import Picture from 'components/Picture';
import LoadingWidget from 'components/LoadingWidget';
import Button from 'components/Button';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';
import STACKS from 'constants/stacks';
import { propTypes } from './deeplinkPropTypes';

const NO_REDIRECT = 'noredirect';
const GO_TO = 'go_to';
const isNonPRODENV = config.getStack() !== STACKS.PROD;

const Deeplink = ({ deeplinkIntoReservationFlow }) => {
  const [showContinueCTA, setShowContinueCTA] = useState(isNonPRODENV);
  const timerRef = useRef(null);

  //  Below Use Effect is specifically to handle modifying the deeplink url link for  NonProd Users,
  // Today, deep links sent via messaging for nonprod environments typically only point to one environment,
  //  despite the “request” for the deep link coming from a different environments.
  // If the deep link processing is relatively quick, users (testers, developers, EM business users) may miss the opportunity to copy the URL.
  // To enable business users to copy/paste and modify the deeplink with regular flow without affecting testing,
  // Also,  making “timeout” logic where the deep link process normally clearsout after some configurable amount of time (e.g. after 5 seconds)

  useEffect(() => {
    // cleared out to prevent any possible memory leak.
    // “pausing” the deep link processing, to allow users to copy/paste the link.
    // skip this condition for non prod users , and this ensures it runs only if its true.
    if (isNonPRODENV) {
      timerRef.current = setTimeout(() => {
        setShowContinueCTA(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const noRedirect = searchParams.has(NO_REDIRECT);
    const goTo = searchParams.get(GO_TO);

    // This condition is specifically delaying executing deeplink url for non prod users.
    if (showContinueCTA) {
      return;
    }

    // If we have a go_to param, skip all other deep link functionality.
    if (goTo) {
      // Get redirect URL for the go_to value
      const redirectUrl = config.getRedirectUrl(goTo);

      // If there is no redirect found or redirects are prevented by noRedirect, log a warning to the console, then redirect to home
      if (noRedirect) {
        // eslint-disable-next-line no-console
        console.log(`Would have redirected to ${goTo}: ${redirectUrl}`);
      } else {
        if (!redirectUrl) {
          // eslint-disable-next-line no-console
          console.warn(`Redirect url not found for go_to value ${goTo}`);
          config.getRedirectUrl(WINDOW_OBJECT_KEYS.HOME_PAGE_URL);
        }

        window.location.assign(redirectUrl);
      }
    } else {
      const options = {
        redirect: !noRedirect,
      };

      deeplinkIntoReservationFlow && location.search && deeplinkIntoReservationFlow(location.search, options);
    }
  }, [deeplinkIntoReservationFlow, showContinueCTA]);

  const handleContinueCTA = () => {
    clearTimeout(timerRef.current);
    setShowContinueCTA(false);
  };

  return (
    <div className='deep-link theme--light'>
      <Picture className='deep-link__logo' src={config.getSiteLogoImage()} alt={i18n('progress_bar_alamo_image_alt')} />
      <h1 className='deep-link__heading'>{i18n('deeplink_header')}</h1>
      <p className='deep-link__copy'>{i18n('deeplink_copy')}</p>
      <LoadingWidget />
      {showContinueCTA && (
        <Button className='deep-link__continue-button' onClick={handleContinueCTA}>
          Continue with Deeplink
        </Button>
      )}
    </div>
  );
};

Deeplink.propTypes = propTypes;

export default Deeplink;
